<template>
  <b-container fluid>
    <iq-card>
        <template v-slot:headerTitle>
            <h4 class="card-title text-center">{{ $t('delivery_management.demand_stock_dashboard') }}</h4>
        </template>
        <template v-slot:body>
            <b-row>
                <b-col lg="6" md="6" sm="12">
                    <b-form-group
                        class="row"
                        label-cols-sm="4"
                        :label="$t('globalTrans.fiscal_year')"
                        label-for="fiscal_year_id"
                        >
                        <b-form-select
                        plain
                        v-model="search.fiscal_year_id"
                        :options="fiscalYearList"
                        id="year"
                        >
                        <template v-slot:first>
                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col lg="6" md="6" sm="12">
                    <b-form-group
                        class="row"
                        label-cols-sm="4"
                        :label="$t('retailerManagement.month')"
                        label-for="month"
                        >
                        <b-form-select
                        plain
                        v-model="search.month"
                        :options="monthList"
                        id="month"
                        >
                        <template v-slot:first>
                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="6" md="6" sm="12">
                    <ValidationProvider name="Division" vid="division_id">
                        <b-form-group
                            class="row"
                            label-cols-sm="4"
                            label-for="division_id"
                            slot-scope="{ valid, errors }"
                        >
                            <template v-slot:label>
                            {{$t('org_pro_division.division')}}
                            </template>
                            <b-form-select
                                plain
                                v-model="search.division_id"
                                :options="divisionList"
                                id="division_id"
                                :state="errors[0] ? false : (valid ? true : null)"
                                :disabled="activeCenter.division_id > 0"
                            >
                            <template v-slot:first>
                                <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                            {{ errors[0] }}
                            </div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col lg="6" md="6" sm="12">
                    <ValidationProvider name="District" vid="district_id">
                        <b-form-group
                            class="row"
                            label-cols-sm="4"
                            label-for="district_id"
                            slot-scope="{ valid, errors }"
                        >
                            <template v-slot:label>
                            {{$t('org_pro_district.district')}}
                            </template>
                            <b-form-select
                                plain
                                v-model="search.district_id"
                                :options="districtList"
                                id="district_id"
                                :state="errors[0] ? false : (valid ? true : null)"
                                :disabled="activeCenter.district_id > 0"
                            >
                            <template v-slot:first>
                                <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                            {{ errors[0] }}
                            </div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="6" md="6" sm="12">
                    <ValidationProvider name="IDSC center" vid="idsc_center_id">
                        <b-form-group
                            class="row"
                            label-cols-sm="4"
                            label-for="idsc_center_id"
                            slot-scope="{ valid, errors }"
                        >
                            <template v-slot:label>
                                {{$t('assitive_device_management.idsc_center')}}
                            </template>
                            <b-form-select
                                plain
                                v-model="search.idsc_center_id"
                                :options="idscCenterList"
                                id="idsc_center_id"
                                :state="errors[0] ? false : (valid ? true : null)"
                                :disabled="activeCenter.value > 0"
                            >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                                {{ errors[0] }}
                            </div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col lg="6" md="6" sm="12">
                    <ValidationProvider name="Assistive Device Name" vid="assistive_device_id">
                        <b-form-group
                            class="row"
                            label-cols-sm="4"
                            label-for="assistive_device_id"
                            slot-scope="{ valid, errors }"
                        >
                            <template v-slot:label>
                                {{$t('assitive_device_management.assistive_device_name')}}
                            </template>
                            <b-form-select
                                plain
                                v-model="search.assistive_device_id"
                                :options="deviceList"
                                id="assistive_device_id"
                                :state="errors[0] ? false : (valid ? true : null)"
                            >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                                {{ errors[0] }}
                            </div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <div class="col-12">
                    <iq-card>
                        <template v-slot:headerTitle>
                            <h4 class="card-title text-center" style="font-size: 16px">{{$t('delivery_management.demand')}}</h4>
                        </template>
                        <template v-slot:body>
                            <hr class="hrclass"/>
                            <b-overlay>
                                <div class="row" aria-hidden="loading | listReload ? 'true' : null" >
                                    <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                                        <div class="seeds-box bg-secondary">
                                            <div class="seeds-box-icon">
                                                <h4 class="text-center text-white">{{ $t('delivery_management.no_of_demand') }}</h4>
                                            </div>
                                            <div class="info text-center">
                                                <!-- <h2>100 M Ton</h2> -->
                                                <div class="d-inline-flex p-2 text-warning text-success"><h2 class="text-white">{{$n(no_of_quantity, { useGrouping: false })}}</h2></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                                        <div class="seeds-box bg-success">
                                            <div class="seeds-box-icon">
                                                <h4 class="text-center text-white">{{ $t('delivery_management.distribution_no') }}</h4>
                                            </div>
                                            <div class="info text-center">
                                                <!-- <h2>100 M Ton</h2> -->
                                                <div class="d-inline-flex p-2 text-warning text-success"><h2 class="text-white">{{$n(distributed_quantity, { useGrouping: false })}}</h2></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                                        <div class="seeds-box" style="background: cadetblue">
                                            <div class="seeds-box-icon">
                                                <h4 class="text-center text-white">{{ $t('delivery_management.pending') }}</h4>
                                            </div>
                                            <div class="info text-center">
                                                <!-- <h2>100 M Ton</h2> -->
                                                <div class="d-inline-flex p-2 text-warning text-success"><h2 class="text-white">{{$n(pending, { useGrouping: false })}}</h2></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-overlay>
                        </template>
                    </iq-card>
                </div>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
        <iq-card>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col>
                    <iq-card style="min-height: 200px">
                        <template v-slot:headerTitle>
                            <h4 class="card-title text-center" style="font-size: 16px">{{$t('delivery_management.stock')}}</h4>
                        </template>
                        <template v-slot:body>
                            <b-overlay>
                                <apexchart class="chart-1 text-center" id="vuechart-example" type="bar" height="250" :options="dataOption" :series="seriesBar"></apexchart>
                            </b-overlay>
                        </template>
                    </iq-card>
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { dashboardData } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import flatpickr from 'flatpickr'

export default {
    mixins: [ModalBaseMasterList],
    components: {
    },
    data () {
        return {
            items: [],
            itemStock: [],
            item: [],
            search: {
                fiscal_year_id: 0,
                month: 0,
                division_id: 0,
                district_id: 0,
                idsc_center_id: 0,
                assistive_device_id: 0
            },
            yearList: [],
            isRetailer: false,
            ItemShow: false,
            districtList: [],
            idscCenterList: [],
            no_of_quantity: [],
            distributed_quantity: [],
            pending: [],
            stock_quantity: [],
            device_name: [],
            device_name_bn: [],
            chartOptions: {
                chart: {
                width: 200,
                type: 'pie'
                },
                legend: {
                position: 'bottom'
                },
                responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                    width: 200
                    },
                    legend: {
                    position: 'bottom'
                    }
                }
                }]
            },
            seriesBar: [{
                name: 'Total:',
                data: []
            }],
            activeCenter: {
                value: 0,
                division_id: 0,
                district_id: 0
            }
        }
    },
    created () {
         if (this.$store.state.dataFilters.officeId) {
          const centerOfficeId = this.$store.state.dataFilters.officeId
          this.activeCenter = this.centerList.find(item => item.office_id === parseInt(centerOfficeId) && item.sales_center_type === 1)
          this.search = Object.assign({}, this.search, {
              division_id: this.activeCenter.division_id,
              district_id: this.activeCenter.district_id,
              idsc_center_id: this.activeCenter.value
          })
        }
        this.loadData()
        const dataCh = []
        const dataChBn = []
        this.$store.state.AwarenessEventService.commonObj.assistiveDeviceList.forEach((data, key) => {
            dataCh.push(data.text_en)
            dataChBn.push(data.text_bn)
        })
        this.device_name = dataCh
        this.device_name_bn = dataChBn
    },
    mounted () {
        flatpickr('.date-picker', {})
        this.search = Object.assign({}, this.search, {
            fiscal_year_id: this.$store.state.currentFiscalYearId,
            month: new Date().getMonth() + 1
        })
    },
    watch: {
        'search.division_id': function (newVal, oldVal) {
            this.districtList = this.getDistrictList(newVal)
            this.idscCenterList = this.getIDSCDivisionList(newVal)
        },
        'search.district_id': function (newVal, oldVal) {
            this.idscCenterList = this.getIDSCDistrictList(newVal)
        }
    },
    computed: {
        dataOption () {
            return {
                chart: {
                id: 'vuechart-example1',
                type: 'bar'
                },
                plotOptions: {
                bar: {
                    barHeight: '200px',
                    columnWidth: '50%',
                    distributed: true,
                    horizontal: false,
                    dataLabels: {
                    position: 'top',
                    horizontalAlign: 'center'
                    }
                }
                },
                labels: this.$i18n.locale === 'bn' ? this.device_name_bn : this.device_name
            }
        },
        i18 () {
            return (this.$i18n.locale === 'bn') ? 1 : 0
        },
        monthList: function () {
            return this.$store.state.commonObj.monthList
        },
        fiscalYearList: function () {
            return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
        },
        centerList: function () {
            return this.$store.state.AwarenessEventService.commonObj.idscCenterList
        },
        deviceList: function () {
            return this.$store.state.AwarenessEventService.commonObj.assistiveDeviceList
        },
        currentLocale () {
            return this.$i18n.locale
        },
        divisionList: function () {
            return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
        }
    },
    methods: {
        loadData () {
          this.item = []
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
            RestApi.getData(awarenessEventServiceBaseUrl, dashboardData, params).then(response => {
                if (response.success) {
                    this.items = this.getRelationalData(response.data)
                    this.itemStock = this.getRelationalStockData(response.stockData)
                    this.$store.dispatch('setList', this.getRelationalData(response.data))
                    this.paginationData(response.data)
                }
                this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
            })
        },
        getRelationalData (data) {
            let demand = 0
            let distribution = 0
            let pending = 0
            data.map(item => {
                demand = item.no_of_quantity
                distribution = item.distributed_quantity
                pending = (item.no_of_quantity) - (item.distributed_quantity)
            })
            this.no_of_quantity = demand
            this.distributed_quantity = distribution
            this.pending = pending
        },
        getRelationalStockData (data) {
            const dataChat = []
            this.$store.state.AwarenessEventService.commonObj.assistiveDeviceList.forEach((item, key) => {
                const deviceInfo = data.find(item1 => item1.assistive_device_id === parseInt(item.value))
                if (typeof deviceInfo !== 'undefined') {
                dataChat.push(deviceInfo.stock_quantity)
                } else {
                dataChat.push(0)
                }
            })
            this.seriesBar = [{
                name: 'Total:',
                data: dataChat
            }]
        },
        searchData () {
          this.loadData()
        },
        getDistrictList (divisionId = null) {
            const districtList = this.$store.state.commonObj.districtList.filter(item => item.status === 0)

            if (divisionId) {
                return districtList.filter(district => district.division_id === divisionId)
            }

            return districtList
        },
        getIDSCDistrictList (idscCenterId = null) {
            const idscCenterList = this.$store.state.AwarenessEventService.commonObj.idscCenterList.filter(item => item.sales_center_type === 1)

            if (idscCenterId) {
                return idscCenterList.filter(item => item.district_id === idscCenterId)
            }

            return idscCenterList
        },
        getIDSCDivisionList (idscCenterId = null) {
            const idscCenterList = this.$store.state.AwarenessEventService.commonObj.idscCenterList.filter(item => item.sales_center_type === 1)

            if (idscCenterId) {
                return idscCenterList.filter(item => item.division_id === idscCenterId)
            }

            return idscCenterList
        }
    }
  }
</script>

<style scoped>
    .bg-delivery {
        background-color: #008082;
    }
    .hrclass {
        border-top: 1px solid rgb(96, 149, 19) !important;
        margin-top: 5px !important;
        margin-bottom: 5px !important;
    }
    .seeds-box {
        border-radius: 3px;
        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
        padding: 10px 0px;
        text-align: right;
        display: block;
        margin-top: 20px;
    }
    .seeds-box-icon {
        background-color: #609513 !important;
        margin: 0 auto;
        margin-top: -20px;
        font-size: 12px !important;
        height: 40px;
        padding-top: 7px;
    }
    .seeds-box-icon span {
        color: #fff;
        display: table-cell;
        text-align: center;
        vertical-align: middle;
    }
    .info h4 {
        font-size: 26px;
        letter-spacing: 2px;
        text-transform: uppercase;
    }
    .info > p {
        color: #717171;
        font-size: 16px;
        padding-top: 10px;
        text-align: justify;
    }
</style>
